module.exports = __webpack_public_path__ + "media/sq_header_aktivni.ec2598a0.mp4";